// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-sHY","col":"styles_col__3fqgH","actions":"styles_actions__3r5HD","conflict":"styles_conflict__1Rnmq"};